/**
 * Bundle Promotion Dynamic Messaging
 * Updates bundle promotion banner based on cart contents
 */

class BundlePromo {
  constructor() {
    this.bannerElement = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.bannerElement = document.querySelector('.bundle-promo span');
    if (this.bannerElement) {
      this.updateBanner();
      this.setupEventListeners();
    }
  }

  /**
   * Extract cart quantity from Dawn's quantity selector label
   */
  getCartQuantity() {
    try {
      const quantityLabel = document.querySelector('.product-form__quantity label');
      if (quantityLabel && quantityLabel.textContent) {
        const match = quantityLabel.textContent.match(/(\d+)\s+in\s+cart/);
        return match ? parseInt(match[1]) : 0;
      }
    } catch (error) {
      console.warn('Could not detect cart quantity:', error);
    }
    return 0;
  }

  /**
   * Generate dynamic message based on cart quantity
   */
  generateMessage(cartQty) {
    switch(cartQty) {
      case 0:
        return "💰 Save 20% on 2 bottles • 25% on 3 bottles";
      case 1:
        return "💰 You have 1 bottle - add 1 more for 20% off!";
      case 2:
        return "💰 You have 2 bottles - add 1 more for 25% off!";
      default: // 3 or more
        return "💰 You have 3+ bottles - enjoy 25% off your bundle!";
    }
  }

  /**
   * Update the banner with dynamic message
   */
  updateBanner() {
    if (!this.bannerElement) return;

    const cartQty = this.getCartQuantity();
    const message = this.generateMessage(cartQty);
    
    // Smooth transition effect
    this.bannerElement.style.transition = 'opacity 0.3s ease';
    this.bannerElement.style.opacity = '0.5';
    
    setTimeout(() => {
      this.bannerElement.textContent = message;
      this.bannerElement.style.opacity = '1';
    }, 150);
  }

  /**
   * Setup event listeners for dynamic updates
   */
  setupEventListeners() {
    // Listen for quantity changes
    const quantityInput = document.querySelector('.product-form__quantity input[type="number"]');
    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        // Small delay to allow cart updates to process
        setTimeout(() => this.updateBanner(), 100);
      });
    }

    // Listen for quantity button clicks
    const quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => this.updateBanner(), 100);
      });
    });

    // Listen for cart updates (if cart drawer is used)
    document.addEventListener('cart:updated', () => {
      setTimeout(() => this.updateBanner(), 200);
    });

    // Listen for variant changes that might affect cart display
    document.addEventListener('variant:change', () => {
      setTimeout(() => this.updateBanner(), 100);
    });
  }
}

// Initialize when script loads
new BundlePromo();